import { Outlet, createFileRoute } from '@tanstack/react-router'
import { BrandMark } from '@/components/layout/brand-mark'
import { WovenBand } from '@/components/layout/woven-band'
import { useBranding } from '@/lib/branding'

/** Layout de las pantallas de acceso (login, cambio obligatorio de contraseña). */
export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
})

/** Lo que la institución resuelve con Tumin; se lee en el panel oscuro de escritorio. */
const AUTH_TAGLINE = 'Del simulador al desembolso, del cobro en campo al cierre contable.'

function AuthLayout() {
  const branding = useBranding()
  return (
    <div className="flex min-h-dvh flex-col bg-background lg:flex-row">
      <aside className="flex flex-col bg-sidebar text-sidebar-foreground lg:w-[44%] lg:max-w-[620px]">
        <WovenBand size="lg" />
        <div className="flex flex-1 flex-col gap-6 px-6 py-6 lg:justify-between lg:px-14 lg:py-14">
          <BrandMark size="lg" showName tone="inverse" />
          <div className="space-y-4">
            <h1 className="sr-only font-heading text-[2.125rem] font-semibold leading-[1.12] tracking-[-0.02em] lg:not-sr-only">{branding.tradeName}</h1>
            <p className="hidden max-w-md lg:block text-[17px] leading-relaxed text-sidebar-muted">{AUTH_TAGLINE}</p>
          </div>
          <p className="hidden text-xs text-sidebar-muted lg:block">{branding.legalName}</p>
        </div>
      </aside>
      <main className="flex flex-1 items-center justify-center px-4 py-10">
        <div className="w-full max-w-[420px]">
          <Outlet />
        </div>
      </main>
      <footer className="pb-6 text-center text-xs text-muted-foreground lg:hidden">{branding.legalName}</footer>
    </div>
  )
}
